'use client';
import { useState, useCallback } from "react";
import { useRouter } from "next/navigation";
import strings from "../config/App.json";
import { toast } from "react-toastify";
import quizApi from "../services/quizApi";

const useFetchQuestions = () => {
    const [loading, setLoading] = useState(false);
    const router = useRouter();

    const fetchQuestions = useCallback(async () => {
        try {
            setLoading(true);
            const questions = await quizApi.getQuestions();

            if (questions && questions.length > 0) {
                localStorage.setItem("questionsData", JSON.stringify(questions));
                router.push(strings.QuestionsAnswersPage);
                return questions;
            } else {
                toast.error("Failed to fetch questions. Please try again.");
                return [];
            }
        } catch (error) {
            toast.error("Something went wrong. Please try again later.");
            return [];
        } finally {
            setLoading(false);
        }
    }, [router]);


    return { fetchQuestions, loading };
};

export default useFetchQuestions;
